import { DragEvent } from 'react';
import { dragProjectMenuItem, MENU_PROJECTS_QUERY_KEY } from '../../../data/planner-data-service';
import { showToast } from '../../../../../common/domain/toast-provider';
import { useMutation, useQueryClient } from '@tanstack/react-query';

interface IProjectMenuDragTargetProps {
    targetProjectId: number;
}

const DRAG_CLASS = 'project-menu__drag-target__over';

const ProjectMenuDragTarget = (props: IProjectMenuDragTargetProps) => {

    const { targetProjectId } = props;

    const queryClient = useQueryClient();

    const { mutate } = useMutation({
        mutationFn: (params: { sourceProjectMenuId: number, targetProjectId: number }) => {
            const { sourceProjectMenuId, targetProjectId} = params;
            return dragProjectMenuItem(
                sourceProjectMenuId,
                targetProjectId,
            );
        },
        onSuccess: (response) => {
            queryClient.setQueryData([MENU_PROJECTS_QUERY_KEY], response);
        },
        onError: () => {
            showToast('Drag project menu item error.');
        }
    });

    const targetOnDragOver = (evt: DragEvent<HTMLDivElement>) => {
        evt.preventDefault();
    };

    const targetOnDragEnter = (evt: DragEvent<HTMLDivElement>) => {
        evt.currentTarget.classList.add(DRAG_CLASS);
    };

    const targetOnDragLeave = (evt: DragEvent<HTMLDivElement>) => {
        evt.currentTarget.classList.remove(DRAG_CLASS);
    };

    /**
     * https://developer.mozilla.org/en-US/docs/Web/API/DataTransfer/setData
     */
    const targetOnDrop = async (evt: DragEvent<HTMLDivElement>) => {
        evt.preventDefault();
        const data = evt.dataTransfer.getData('text');

        if(data === null ||
            data === undefined ||
            data.trim() === '' ||
            isNaN(Number(data))) {
            showToast('Drop project menu item error.');
            return;
        }

        const sourceProjectMenuId = Number(data);

        mutate({
            sourceProjectMenuId,
            targetProjectId,
        });
    };

    return (
        <div
            onDragOver={ targetOnDragOver }
            onDragEnter={ targetOnDragEnter }
            onDragLeave={ targetOnDragLeave }
            onDrop={ targetOnDrop }
            className="project-menu__drag-target w-full h-[5px] bg-slate-500 rounded my-1 hidden"
        ></div>
    )
};

export default ProjectMenuDragTarget;